import { v4 as uuid } from "uuid";
import { Survey } from "../types/survey";

export const cloneSurveyWithNewIds = (survey: Survey): Survey => {
  const questionIdMap = new Map<string, string>();

  // собрать map questionId → newQuestionId
  survey.items.forEach((item) => {
    if (item.question) {
      questionIdMap.set(item.question.id, uuid());
    }

    if (item.section) {
      item.section.questions.forEach((q) => {
        questionIdMap.set(q.id, uuid());
      });
    }
  });

  return {
    ...survey,
    id: undefined,
    createdAt: undefined,
    updatedAt: undefined,

    items: survey.items.map((item) => ({
      ...item,
      id: uuid(),

      question: item.question
        ? {
            ...item.question,
            id: questionIdMap.get(item.question.id)!,

            answers: item.question.answers.map((answer) => ({
              ...answer,
              id: uuid(),

              logic: answer.logic.map((logic) => ({
                ...logic,
                actions: logic.actions.map((action) => ({
                  ...action,
                  targetFieldId:
                    action.targetFieldId &&
                    questionIdMap.get(action.targetFieldId)
                      ? questionIdMap.get(action.targetFieldId)!
                      : action.targetFieldId,
                })),
              })),
            })),
          }
        : null,

      section: item.section
        ? {
            ...item.section,
            id: uuid(),

            questions: item.section.questions.map((q) => ({
              ...q,
              id: questionIdMap.get(q.id)!,

              answers: q.answers.map((a) => ({
                ...a,
                id: uuid(),

                logic: a.logic.map((logic) => ({
                  ...logic,
                  actions: logic.actions.map((action) => ({
                    ...action,
                    targetFieldId:
                      action.targetFieldId &&
                      questionIdMap.get(action.targetFieldId)
                        ? questionIdMap.get(action.targetFieldId)!
                        : action.targetFieldId,
                  })),
                })),
              })),
            })),
          }
        : null,
    })),
  };
};
